import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  FormattedMessage,
  intlShape,
  injectIntl,
  FormattedHTMLMessage,
} from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import _ from 'lodash';
import Linkify from 'linkify-it';
import { connect } from 'react-redux';
import { Cookies, withCookies } from 'react-cookie';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import Modal from '@material-ui/core/Modal';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import Collapse from '@material-ui/core/Collapse';
import Snackbar from '@material-ui/core/Snackbar';
import EditIcon from '@material-ui/icons/Edit';
import RemoveIcon from '@material-ui/icons/Delete';

import { Interweave } from 'interweave';
import * as tourActions from '../../../actions/tours';

import RestrictedAccessModal from '../../../components/RestrictedAccessModal/RestrictedAccessModal';
import ConfirmDeleteDialog from '../../../components/statelessComponents/ConfirmDeleteDialog';
import Link from '../../../components/Link';
import LinkedTabs from '../../../components/statelessComponents/Tabs';
import ConfirmDeleteDescription from '../ConfirmDeleteDescription/ConfirmDeleteDescription';

import * as authActions from '../../../actions/auth';
import * as courseDetailsActions from '../../../actions/courseDetails';

import {
  isTourShown,
  isTrial,
  isProfessionalMainGroup,
  getStreamChatUrl,
  isUserFromWhitelabeledOrganization,
  userSkillEvaluationEnabled,
  isWhitelabeledOrganizationAdmin,
} from '../../../helpers';
import isLoggedIn from '../../../helpers/checkAuth';

import history from '../../../history';
import LivestreamBadge from '../LivestreamBadge/LivestreamBadge';

import messages from './coursedetailsHeaderMessages';

import s from './CourseDetailsHeader.scss';
import large from '../../../components/large_screen.scss';
import secondary from '../../../components/statelessComponents/Tabs/presetsTabsScss/Secondary.scss';
import SkholeIcon21 from '../../../components/statelessComponents/Icons/SkholeIcon21';
import SkholeIcon03 from '../../../components/statelessComponents/Icons/SkholeIcon03';
import SkholeIcon02 from '../../../components/statelessComponents/Icons/SkholeIcon02';
import * as lessonDetailsActions from '../../../actions/lessonDetails';
import * as podcastLessonActions from '../../../actions/podcastLesson';
import { CopyIcon } from '../../../components/statelessComponents/Icons';

function escape(str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

const linkify = Linkify();

function getLinkifiedContent(content) {
  const result = [];
  let out = escape(content);
  const matches = linkify.match(content);
  let last;

  if (matches) {
    last = 0;
    matches.forEach(match => {
      if (last < match.index) {
        result.push(
          escape(content.slice(last, match.index)).replace(/\r?\n/g, '<br>'),
        );
      }
      result.push('<a target="_blank" href="');
      result.push(escape(match.url));
      result.push('">');
      result.push(escape(match.text));
      result.push('</a>');
      last = match.lastIndex;
    });
    if (last < content.length) {
      result.push(escape(content.slice(last)).replace(/\r?\n/g, '<br>'));
    }
    out = result.join('');
  }

  return out;
}

@withCookies
@injectIntl
@withStyles(s)
@withStyles(large)
@withStyles(secondary)
@connect(
  state => ({
    auth: state.auth,
    loading: state.courseDetails.loading,
    course: state.courseDetails.course,
    error: state.courseDetails.error,
    favoriteCourses: state.auth.favoriteCourses,
    relatedCourses: state.courseDetails.relatedCourses,
    loadingRelatedCourses: state.courseDetails.loadingRelatedCourses,
    totalRelatedCourses: state.courseDetails.totalRelatedCourses,
    textNotes: state.courseDetails.textNotes,
    videoNotes: state.courseDetails.videoNotes,
    totalDiscussions: state.discussions.total,
    lang: state.intl.locale,
    isTourOpen: isTourShown(state, 'courseDetails'),
    isLiveStreamChatShown: state.courseDetails.isLiveStreamChatShown,
    playPodcastAudio: state.podcastLesson.playPodcastAudio,
    openedPodcastLesson: state.podcastLesson.openedPodcastLesson,
    lesson: state.lessonDetails.lesson,
  }),
  dispatch =>
    bindActionCreators(
      {
        loadAuth: authActions.loadAuth,
        saveFavoriteCourses: authActions.saveFavoriteCourses,
        getRelatedCourses: courseDetailsActions.getRelatedCourses,
        toggleTour: tourActions.toggleTour,
        resetCourseProgress: courseDetailsActions.resetCourseProgress,
        getCourseBySlug: courseDetailsActions.getCourseBySlug,
        toggleChat: courseDetailsActions.toggleChat,
        getLessonBySlug: lessonDetailsActions.getLessonBySlug,
        setOpenedPodcastLesson: podcastLessonActions.setOpenedPodcastLesson,
        setIsLoadingPodcastLesson: podcastLessonActions.setIsLoading,
        setPlayPodcastAudio: podcastLessonActions.setPlayPodcastAudio,
      },
      dispatch,
    ),
)
export default class CourseDetailsHeader extends Component {
  static propTypes = {
    auth: PropTypes.object, // eslint-disable-line
    course: PropTypes.object, // eslint-disable-line
    favoriteCourses: PropTypes.array.isRequired, // eslint-disable-line
    loading: PropTypes.bool.isRequired,
    saveFavoriteCourses: PropTypes.func.isRequired,
    getCourseBySlug: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    textNotes: PropTypes.array.isRequired, // eslint-disable-line
    videoNotes: PropTypes.array.isRequired, // eslint-disable-line
    lang: PropTypes.string.isRequired,
    loadingRelations: PropTypes.bool,
    courseRelations: PropTypes.shape({}),
    cookies: PropTypes.instanceOf(Cookies).isRequired,
    toggleTour: PropTypes.func.isRequired,
    isTourOpen: PropTypes.bool.isRequired,
    totalDiscussions: PropTypes.number.isRequired,
    loadAuth: PropTypes.func.isRequired,
    toggleChat: PropTypes.func.isRequired,
    isLiveStreamChatShown: PropTypes.bool.isRequired,
    streamingNow: PropTypes.bool.isRequired,
    timeLeft: PropTypes.bool.isRequired,
    videoId: PropTypes.string,
    videoService: PropTypes.string,
    videoAppId: PropTypes.string,
    resetCourseProgress: PropTypes.func.isRequired,
    openedPodcastLesson: PropTypes.string,
    setOpenedPodcastLesson: PropTypes.func,
    playPodcastAudio: PropTypes.bool,
    getFirstPodcastLesson: PropTypes.func,
    setIsLoadingPodcastLesson: PropTypes.func.isRequired,
    setPlayPodcastAudio: PropTypes.func.isRequired,
    lesson: PropTypes.object, // eslint-disable-line
    disableContinueToBtn: PropTypes.bool,
    getLessonBySlug: PropTypes.func.isRequired,
  };

  static defaultProps = {
    course: {},
    courseRelations: {},
    loadingRelations: false,
    videoId: '',
    videoService: '',
    videoAppId: '',
    openedPodcastLesson: '',
    setOpenedPodcastLesson: _.noop,
    playPodcastAudio: false,
    getFirstPodcastLesson: _.noop,
    lesson: {},
    disableContinueToBtn: false,
  };

  static contextTypes = {
    fetch: PropTypes.func,
    route: PropTypes.shape({}),
    cloudfrontUrl: PropTypes.string,
    cookiePrefix: PropTypes.string,
    apiUrl: PropTypes.string,
    togglePwa: PropTypes.string,
    organizationSlug: PropTypes.string,
    whitelabeling: PropTypes.shape({}),
    vimeoLivestreamUrl: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      isShown: false,
      isCourseFavoriting: false,
      isRestrictedAccessModalOpened: false,
      isConfirmDeleteOpen: false,
      isDeleting: false,
      isDeleted: false,
      deletingError: '',
      isOldBrowserWarning: false,
      isCourseProgressResetting: false,
      isCourseProgressReset: false,
      isDescriptionShort: _.size(props.course.description) < 750,
      linkifiedDescription: getLinkifiedContent(props.course.description || ''),
      chatUrl: '',
      isConfirmCopyOpen: false,
    };
  }

  async componentDidMount() {
    const { videoId, videoService, videoAppId, course } = this.props;
    const chatUrl = await getStreamChatUrl(
      course.youtubeVideoUrl,
      { videoId, videoService, videoAppId },
      this.context,
    );

    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ chatUrl });
  }

  async componentWillReceiveProps(nextProps) {
    if (
      this.props.course._id &&
      nextProps.course._id &&
      this.props.course._id !== nextProps.course._id
    ) {
      const { videoId, videoService, videoAppId, course } = nextProps;

      const chatUrl = await getStreamChatUrl(
        course.youtubeVideoUrl,
        { videoId, videoService, videoAppId },
        this.context,
      );

      const linkifiedDescription = getLinkifiedContent(
        course.description || '',
      );
      if (linkifiedDescription !== this.state.linkifiedDescription) {
        this.setState({ linkifiedDescription });
      }

      if (chatUrl !== this.state.chatUrl) {
        this.setState({ chatUrl });
      }
    }
  }

  getCurrentTabIndex = () => {
    const {
      route: { path },
    } = this.context;

    let tabIndex = 'content';

    switch (path) {
      case '/:lang/courses/:courseSlug/discussions/:discussionId':
      case '/:lang/:organizationSlug/courses/:courseSlug/discussions/:discussionId': {
        tabIndex = 'discussions';
        break;
      }
      case '/:lang/courses/:courseSlug/discussions':
      case '/:lang/:organizationSlug/courses/:courseSlug/discussions': {
        tabIndex = 'discussions';
        break;
      }
      case '/:lang/courses/:courseSlug/notes':
      case '/:lang/:organizationSlug/courses/:courseSlug/notes': {
        tabIndex = 'notes';
        break;
      }
      default: {
        tabIndex = 'content';
      }
    }

    return tabIndex;
  };

  showConfirmDelete = () => {
    this.setState({
      isConfirmDeleteOpen: true,
      isDeleted: false,
      deletingError: '',
    });
  };

  hideConfirmDelete = () => {
    this.setState({
      isConfirmDeleteOpen: false,
    });
  };

  showConfirmCopy = () => {
    this.setState({
      isConfirmCopyOpen: true,
    });
  };

  hideConfirmCopy = () => {
    this.setState({
      isConfirmCopyOpen: false,
    });
  };

  hideConfirmDeleteSnackbar = () => {
    this.setState({
      isDeleted: false,
      deletingError: '',
    });
  };

  removeCourse = () => {
    const { course, lang } = this.props;
    const { organizationSlug } = this.context;

    this.setState({
      isDeleting: true,
      deletingError: '',
    });

    this.context
      .fetch(`/api/courses/${course._id}?forever`, {
        method: 'DELETE',
      })
      .then(async res => {
        const resText = await res.text();

        if (res.ok) {
          return;
        }

        const json = resText ? JSON.parse(resText) : {};

        throw new Error(json.message);
      })
      .then(() => {
        this.setState({
          isDeleting: false,
          isDeleted: true,
        });
        this.hideConfirmDelete();
        history.replace(
          `/${lang}${organizationSlug ? `/${organizationSlug}` : ''}`,
        );
      })
      .catch(deletingError => {
        this.setState({
          isDeleting: false,
          deletingError: deletingError.message,
        });

        console.error(deletingError);
      });
  };

  toggleTelCom = () => {
    window.Intercom('show');
  };

  closeRestrictedAccessModal = () => {
    this.setState({
      isRestrictedAccessModalOpened: false,
    });
  };

  toggleCollapseDescription = () =>
    this.setState(prevState => ({ isShown: !prevState.isShown }));

  toggleFavorite = _id => {
    const { favoriteCourses, saveFavoriteCourses } = this.props;

    if (favoriteCourses.includes(_id)) {
      return this.context
        .fetch(`/api/auth/favorite-courses/${_id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': undefined,
            Accept: '*/*',
          },
        })
        .then(() => saveFavoriteCourses(_.without(favoriteCourses, _id)))
        .then(() => {
          this.setState({
            isCourseFavoriting: false,
          });
        })
        .catch(error => {
          console.error(error);
          this.setState({
            isCourseFavoriting: false,
          });
        });
    }

    this.setState({
      isCourseFavoriting: true,
    });

    return this.context
      .fetch(`/api/auth/favorite-courses/${_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': undefined,
          Accept: '*/*',
        },
      })
      .then(() => saveFavoriteCourses(favoriteCourses.concat([_id])))
      .then(() => {
        this.setState({
          isCourseFavoriting: false,
        });
      })
      .catch(error => {
        console.error(error);
        this.setState({
          isCourseFavoriting: false,
        });
      });
  };

  handleCloseOldBrowserSnackbar = () => {
    this.setState({
      isOldBrowserWarning: false,
    });
  };

  hasAccess = () => {
    const { auth, course } = this.props;

    return isLoggedIn(auth) && course.isAvailable;
  };

  checkAuth = (event, data) => {
    const forbidForTrial = data && data.forbidForTrial;
    const { auth } = this.props;

    if (this.hasAccess() && (!forbidForTrial || !isTrial(auth))) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    this.setState({
      isRestrictedAccessModalOpened: true,
    });
  };

  resetCourseProgress = () => {
    const {
      course,
      getCourseBySlug,
      resetCourseProgress,
      setOpenedPodcastLesson,
      getFirstPodcastLesson,
    } = this.props;

    const { fetch } = this.context;

    this.setState({
      isCourseProgressResetting: true,
      isCourseProgressReset: false,
    });

    resetCourseProgress();
    setOpenedPodcastLesson(null);

    return fetch(`/api/courses/${course._id}/reset-progress`, {
      method: 'PUT',
    })
      .then(async res => {
        if (!res.ok) {
          return res.json();
        }

        this.setState({
          isCourseProgressResetting: false,
          isCourseProgressReset: true,
          isConfirmResetOpen: false,
        });
        return getCourseBySlug(course.slug);
      })
      .then(() => {
        if (course.type === 'podcast' && course.totalLessons === 1) {
          return getFirstPodcastLesson();
        }
        return Promise.resolve();
      })
      .catch(error => {
        console.error(error);
        this.setState({
          isCourseProgressResetting: false,
          resettingError: error && error.message,
        });
      });
  };

  toggleConfirmReset = isConfirmResetOpen => {
    this.setState({ isConfirmResetOpen });
  };

  hideConfirmResetSnackbar = () => {
    this.setState({
      isCourseProgressReset: false,
    });
  };

  startPlayingPodcast = async nextItem => {
    const {
      setOpenedPodcastLesson,
      getLessonBySlug,
      course,
      setIsLoadingPodcastLesson,
      lesson,
      setPlayPodcastAudio,
    } = this.props;
    if (course.type !== 'podcast') {
      return;
    }
    if (_.get(lesson, '_id') === _.get(nextItem, 'item._id')) {
      setPlayPodcastAudio(true);
      return;
    }
    setIsLoadingPodcastLesson(true);
    await getLessonBySlug(_.get(nextItem, 'item.slug'), {
      courseId: course._id,
    });
    setOpenedPodcastLesson(_.get(nextItem, 'item._id'), true, true);
    setIsLoadingPodcastLesson(false);
  };

  render() {
    const {
      course,
      favoriteCourses,
      auth,
      intl: { formatMessage },
      textNotes,
      videoNotes,
      lang,
      loadingRelations,
      courseRelations,
      totalDiscussions,
      toggleChat,
      isLiveStreamChatShown,
      streamingNow,
      timeLeft,
      videoService,
      openedPodcastLesson,
      lesson,
      playPodcastAudio,
      disableContinueToBtn,
    } = this.props;

    const {
      isCourseFavoriting,
      isRestrictedAccessModalOpened,
      isShown,
      isConfirmDeleteOpen,
      isConfirmCopyOpen,
      isDeleting,
      isDeleted,
      deletingError,
      isOldBrowserWarning,
      isCourseProgressResetting,
      resettingError,
      isCourseProgressReset,
      isConfirmResetOpen,
      isDescriptionShort,
      linkifiedDescription,
      chatUrl,
    } = this.state;

    const { organizationSlug } = this.context;

    const courseItems = _((course && course.sections) || [])
      .map('items')
      .flatten()
      .value();

    const completedSectionItemsNumber =
      course.completedLessons + course.completedQuizzes;

    let nextItem = _.find(
      courseItems,
      ({ item, isCompleted }) =>
        item._id === course.lastAccessItemId && !isCompleted,
    );

    if (!nextItem) {
      nextItem = courseItems.find(item => item.isCompleted === false);
    }

    if (!isLoggedIn(auth)) {
      nextItem = courseItems[0];
    }

    const showEvaluationModal = item => {
      const isWhitelabeled = isUserFromWhitelabeledOrganization(auth);
      const isUserSkillEvaluationEnabled = userSkillEvaluationEnabled(auth);

      return (
        (!isWhitelabeled || isUserSkillEvaluationEnabled) &&
        !_.get(course, 'isUserSkillEvaluated') &&
        !course.progress &&
        !completedSectionItemsNumber &&
        _.get(course, 'sections[0].items[0].item._id') ===
          _.get(item, 'item._id')
      );
    };

    let nextUrl;

    if (nextItem && nextItem.itemType === 'Quiz') {
      nextUrl = `/courses/${course.slug}/quizzes/${_.get(
        nextItem,
        'item._id',
        '',
      )}${showEvaluationModal(nextItem) ? '?showEvaluationModal' : ''}`;
    }

    if (nextItem && nextItem.itemType === 'Lesson') {
      nextUrl = `/courses/${course.slug}/lessons/${_.get(
        nextItem,
        'item.slug',
        '',
      )}${showEvaluationModal(nextItem) ? '?showEvaluationModal' : ''}`;
    }

    if (nextItem && course.type === 'podcast') {
      nextUrl = `/courses/${course.slug}`;
    }

    const isFavorite = (favoriteCourses || []).includes(course._id);

    const hasNotes = !![]
      .concat(_.reject(_.map(textNotes, 'notes'), item => !item.length))
      .concat(_.reject(_.map(videoNotes, 'notes'), item => !item.length))
      .length;

    const notesCount =
      _.sumBy(textNotes, item => item.notes.length) +
      _.sumBy(videoNotes, item => item.notes.length);

    let discussionsLabel = formatMessage(messages.discussionTabLabel);
    let notesLabel = formatMessage(messages.notesTabLabel);

    if (isLoggedIn(auth)) {
      discussionsLabel = formatMessage(messages.discussionTabLabelWithCount, {
        count: totalDiscussions > 100 ? '99+' : totalDiscussions,
      });
      notesLabel = formatMessage(messages.notesTabLabelWithCount, {
        count: notesCount > 100 ? '99+' : notesCount,
      });
    }

    const courseDescriptionLines =
      ((course.description || '').match(/\n/g) || '').length + 1;
    const courseDescriptionLength = _.get(course, 'description.length', 0);
    const shouldBeCollapsed =
      courseDescriptionLines > 3 || courseDescriptionLength > 150;

    return (
      <>
        <section
          className={classNames(s.topPart, {
            [s.livestream]: course.type === 'livestream',
          })}
          style={{
            backgroundImage: `url(${this.context.cloudfrontUrl}/${_.get(
              course,
              'image.path',
              'default.svg',
            )})`,
          }}
        >
          <div className={classNames(s.topPartContent, large.generalSection)}>
            <Typography
              variant="h1"
              className={classNames(s.title, {
                [s.notDisplayOnMobile]:
                  course.type === 'livestream' && timeLeft < 0,
              })}
              data-test="course-title"
            >
              {course.name}
            </Typography>
            {!!course.time && (
              <Typography className={s.mediaDurations}>
                <FormattedMessage {...messages.mediaDurations} />
                &nbsp;
                {!!course.timeHours && [
                  <FormattedMessage
                    {...messages.studyTimeHours}
                    values={{ time: course.timeHours }}
                  />,
                  ' ',
                ]}
                {!!course.timeMinutes && (
                  <FormattedMessage
                    {...messages.studyTimeMinutes}
                    values={{ time: course.timeMinutes }}
                  />
                )}
              </Typography>
            )}
            {!!course.studyTimeEstimation &&
              course.studyTimeEstimationType !== 'hide' && (
                <Typography className={s.studyTime}>
                  <FormattedMessage {...messages.recommendedStudyTime} />
                  &nbsp;
                  {!!course.studyTimeEstimationHours && [
                    <FormattedMessage
                      {...messages.studyTimeHours}
                      values={{ time: course.studyTimeEstimationHours }}
                    />,
                    ' ',
                  ]}
                  {!!course.studyTimeEstimationMinutes && (
                    <FormattedMessage
                      {...messages.studyTimeMinutes}
                      values={{ time: course.studyTimeEstimationMinutes }}
                    />
                  )}
                </Typography>
              )}
            <LivestreamBadge
              timeLeft={timeLeft}
              course={course}
              streamingNow={streamingNow}
              className={classNames({ [s.notDisplayOnTablet]: timeLeft <= 0 })}
            />
            <Typography
              className={classNames(s.description, s.notDisplayOnMobile, {
                [s.width75]: isDescriptionShort && course.type === 'livestream',
              })}
            >
              <Interweave content={linkifiedDescription} />
            </Typography>
            {!_.isEmpty(course.description) && (
              <Collapse
                className={classNames(s.descriptionOnlyMobile, {
                  [s.livestreamDescriptionMobile]: course.type === 'livestream',
                })}
                in={isShown}
                collapsedHeight="62px"
              >
                <Typography className={s.descrText}>
                  <Interweave content={linkifiedDescription} />
                </Typography>
                {shouldBeCollapsed && isShown && (
                  <Button
                    data-test-id="pzpIhhUkgUcADC9j23bCp"
                    className={classNames(s.collapseReadBtn, {
                      [s.livestream]: course.type === 'livestream',
                    })}
                    onClick={this.toggleCollapseDescription}
                  >
                    {formatMessage(messages.hideLabel)}
                  </Button>
                )}
              </Collapse>
            )}
            {shouldBeCollapsed && !isShown && (
              <Button
                data-test-id="QleQ0Xgtv08VtK6NjXR68"
                className={classNames(s.collapseReadBtn, {
                  [s.livestream]: course.type === 'livestream',
                })}
                onClick={this.toggleCollapseDescription}
              >
                {formatMessage(messages.readMoreLabel)}
              </Button>
            )}
            <div
              className={classNames(s.courseActions, {
                [s.actionsBlockLivestream]:
                  !course.certificate && course.type === 'livestream',
              })}
            >
              <div className={classNames(s.leftActionsBlock)}>
                {((nextItem && this.hasAccess()) ||
                  _.get(nextItem, 'item.isGloballyFree')) && (
                  <Tooltip
                    title={
                      _.get(nextItem, 'item.name', '').length > 19 &&
                      completedSectionItemsNumber
                        ? formatMessage(messages.continueToBtnLabel, {
                            lessonName: _.get(nextItem, 'item.name', ''),
                          })
                        : ''
                    }
                  >
                    <Button
                      data-test-id="EMHLA0hT5YYVzxqh-dlRs"
                      component={Link}
                      className={s.button}
                      id="start-course-btn"
                      variant="contained"
                      classes={{
                        label: classNames(s.actionLabel, {
                          [s.smallActionLabel]:
                            course.certificate &&
                            _.get(nextItem && nextItem, 'item.name', '')
                              .length > 19,
                        }),
                        disabled: s.disabledBtn,
                      }}
                      disabled={
                        course.type === 'podcast' &&
                        ((openedPodcastLesson &&
                          playPodcastAudio &&
                          _.get(lesson, 'audios.length')) ||
                          disableContinueToBtn)
                      }
                      to={nextUrl}
                      onClick={
                        course.type !== 'podcast'
                          ? _.noop
                          : () => this.startPlayingPodcast(nextItem)
                      }
                    >
                      <SkholeIcon21 className={s.playIconBtn} color="#fff" />
                      {completedSectionItemsNumber ? (
                        <FormattedMessage
                          {...messages.continueToBtnLabel}
                          values={{
                            lessonName: _.get(nextItem, 'item.name', ''),
                          }}
                        />
                      ) : (
                        <FormattedMessage {...messages.startBtnLabel} />
                      )}
                    </Button>
                  </Tooltip>
                )}
                {!this.hasAccess() &&
                  !_.get(nextItem, 'item.isGloballyFree') &&
                  course.type !== 'livestream' && (
                    <Button
                      data-test-id="bcY4SjdP56YTX8jZYywNZ"
                      onClick={this.checkAuth}
                      className={s.button}
                      classes={{
                        label: s.actionLabel,
                      }}
                    >
                      <SkholeIcon21 className={s.playIconBtn} color="#fff" />
                      <FormattedMessage {...messages.startBtnLabel} />
                    </Button>
                  )}
                {course.certificate && (
                  <Button
                    href={`/${lang}${
                      organizationSlug ? `/${organizationSlug}` : ''
                    }/cert/${course.certificate.code}`}
                    component="a"
                    target="_blank"
                    variant="contained"
                    className={classNames(s.button)}
                    classes={{
                      label: s.actionLabel,
                    }}
                  >
                    <FormattedMessage {...messages.showCertificateBtnLabel} />
                  </Button>
                )}
                {this.hasAccess() &&
                  !!course.progress &&
                  course.type !== 'livestream' && (
                    <Button
                      data-test-id="RHtrxWimEXfCM8C_LDU29"
                      onClick={() => this.toggleConfirmReset(true)}
                      disabled={isCourseProgressResetting}
                      className={s.button}
                      classes={{
                        label: s.actionLabel,
                      }}
                      variant="contained"
                      id="restart-course-btn"
                    >
                      <FormattedMessage {...messages.resetCourseProgress} />
                    </Button>
                  )}
              </div>
              {course.type === 'livestream' &&
                timeLeft <= 0 &&
                course.enableStreamChat && (
                  <Button
                    data-test-id="a6vNEipJcuVGw9tMD8TzR"
                    className={classNames(s.button, s.notDisplayOnMobile)}
                    classes={{
                      label: s.actionLabel,
                    }}
                    type="button"
                    onClick={toggleChat}
                  >
                    {!isLiveStreamChatShown && (
                      <FormattedMessage {...messages.viewLivestreamChat} />
                    )}
                    {isLiveStreamChatShown && (
                      <FormattedMessage {...messages.hideLivestreamChat} />
                    )}
                  </Button>
                )}
              {course.type === 'livestream' &&
                timeLeft <= 0 &&
                course.enableStreamChat &&
                videoService === 'vimeo' && (
                  <Button
                    className={classNames(s.button, s.notDisplayOnDesktop)}
                    classes={{
                      label: s.actionLabel,
                    }}
                    href={chatUrl}
                    target="_blank"
                  >
                    <FormattedMessage {...messages.viewLivestreamChat} />
                  </Button>
                )}
              {this.hasAccess() && (
                <Button
                  data-test-id="z0YcrG8-RTtDkFTo2RHuc"
                  variant="contained"
                  className={classNames(
                    s.transparentBtn,
                    s.button,
                    s.notDisplayOnMobile,
                  )}
                  onClick={this.toggleTelCom}
                >
                  <FormattedMessage {...messages.giveCourseFedbackLabel} />
                </Button>
              )}
            </div>
            {course.type !== 'livestream' && _.has(course, 'progress') && (
              <>
                <LinearProgress
                  variant="determinate"
                  value={course.progress}
                  className={s.progress}
                  classes={{ colorPrimary: s.progressBarColorPrimary }}
                  aria-label={formatMessage(messages.progressBarLabel)}
                />
                <Typography
                  variant="h6"
                  component="h2"
                  className={s.progressValue}
                >
                  {course.progress}%
                </Typography>
              </>
            )}
            {isLoggedIn(auth) && (
              <Button
                data-test-id="2u0DN4JA_o8I-h6Ybw-AA"
                className={classNames({
                  [s.removeFromFavorite]: isFavorite,
                  [s.addToFavorite]: !isFavorite,
                })}
                onClick={() => this.toggleFavorite(course._id)}
                disabled={isCourseFavoriting}
              >
                {!isFavorite ? (
                  <FormattedMessage {...messages.addToBtnLabel} />
                ) : (
                  <FormattedMessage {...messages.removeFromBtnLabel} />
                )}
                {isFavorite ? (
                  <SkholeIcon02 className={s.favoriteCourseIcon} color="#fff" />
                ) : (
                  <SkholeIcon03
                    className={s.favoriteCourseIconBorder}
                    color="#fff"
                  />
                )}
              </Button>
            )}
          </div>
          {course.type !== 'livestream' && (
            <nav className={classNames(s.tabsBlock, large.generalSection)}>
              <LinkedTabs
                currentTabIndex={this.getCurrentTabIndex()}
                classes={{
                  root: secondary.root,
                  scrollButtons: secondary.scrollButtons,
                  tabsIndicator: secondary.tabsIndicator,
                  tabRoot: secondary.tabRoot,
                  tabLabel: secondary.tabLabel,
                }}
                tabs={[
                  {
                    label: formatMessage(messages.contentTabLabel),
                    linkTo: `/courses/${course.slug}`,
                    value: 'content',
                  },
                  ...[
                    {
                      label: discussionsLabel,
                      linkTo: `/courses/${course.slug}/discussions`,
                      onClick: event =>
                        this.checkAuth(event, { forbidForTrial: true }),
                      value: 'discussions',
                    },
                  ],
                  (hasNotes || !isLoggedIn(auth)) &&
                    course.type !== 'podcast' && {
                      label: notesLabel,
                      linkTo: `/courses/${course.slug}/notes`,
                      onClick: this.checkAuth,
                      value: 'notes',
                    },
                ]}
              />
            </nav>
          )}
          <Modal
            open={isRestrictedAccessModalOpened}
            onClose={this.closeRestrictedAccessModal}
          >
            <RestrictedAccessModal onClose={this.closeRestrictedAccessModal} />
          </Modal>
        </section>
        {course.hasEditPermission && isWhitelabeledOrganizationAdmin(auth) && (
          <div className={s.copyBtn}>
            <Tooltip title={formatMessage(messages.copyBtn)}>
              <Fab
                data-test-id="ZA4sWEy58QkHjuxT4c0sS"
                color="primary"
                type="button"
                className={s.btn}
                onClick={this.showConfirmCopy}
                id="copy-course-btn"
              >
                <CopyIcon color="secondary" />
              </Fab>
            </Tooltip>
          </div>
        )}
        {course.hasEditPermission && (
          <div>
            <div className={s.editBtn}>
              <Tooltip title={formatMessage(messages.editCourse)}>
                <Fab
                  color="primary"
                  className={s.btn}
                  aria-label={formatMessage(messages.editCourseBtnLabel)}
                  component={Link}
                  to={`/edit/courses/${course._id}`}
                  id="edit-course-btn"
                >
                  <EditIcon />
                </Fab>
              </Tooltip>
            </div>
          </div>
        )}
        {course.hasFullEditPermission && (
          <div className={s.deleteBtn}>
            <Tooltip title={formatMessage(messages.deleteBtn)}>
              <Fab
                data-test-id="zAW9C_E47EQexu7tBo2dv"
                color="secondary"
                type="button"
                className={s.btn}
                onClick={this.showConfirmDelete}
                disabled={isDeleting}
                id="remove-course-btn"
              >
                <RemoveIcon />
              </Fab>
            </Tooltip>
          </div>
        )}
        <ConfirmDeleteDialog
          isShown={isConfirmCopyOpen}
          onClose={this.hideConfirmCopy}
          deleteBtnId="confirm-copy-course"
          submitColor="primary"
          deleteBtnLabel={
            <Link
              className={s.copyConfirmBtn}
              to={`/edit/courses/new?courseIdToCopy=${course._id}`}
            >
              <FormattedMessage {...messages.copyConfirmationSubmitLabel} />
            </Link>
          }
          title={<FormattedMessage {...messages.copyConfirmationTitle} />}
          disableBackdropClick
          isDeleting={false}
        />
        <ConfirmDeleteDialog
          isShown={isConfirmDeleteOpen}
          onClose={this.hideConfirmDelete}
          onCloseSnackbar={this.hideConfirmDeleteSnackbar}
          submit={this.removeCourse}
          isDeleting={isDeleting || loadingRelations}
          isDeleted={isDeleted}
          deletingError={deletingError}
          title={
            <FormattedMessage
              {...messages.submitDeleteItemMsg}
              values={{
                name: _.get(course, 'name', '').toLowerCase(),
              }}
            />
          }
          snackbarMessage={
            <FormattedHTMLMessage
              {...messages.itemRemoved}
              values={{
                name: _.get(course, 'name', ''),
              }}
            />
          }
          description={
            <div>
              {loadingRelations && (
                <div className={s.loadingWrapper}>
                  <CircularProgress size={100} thickness={4} />
                </div>
              )}
              {!loadingRelations && (
                <ConfirmDeleteDescription courseRelations={courseRelations} />
              )}
            </div>
          }
          id="confirm-remove-course-dialog"
        />
        <ConfirmDeleteDialog
          isShown={isConfirmResetOpen}
          onClose={() => this.toggleConfirmReset(false)}
          onCloseSnackbar={this.hideConfirmResetSnackbar}
          submit={this.resetCourseProgress}
          isDeleting={isCourseProgressResetting}
          isDeleted={isCourseProgressReset}
          deletingError={resettingError}
          deleteBtnId="confirm-reset-course-btn"
          title={<FormattedMessage {...messages.resetCourseTitle} />}
          snackbarMessage={
            <FormattedHTMLMessage
              {...messages.courseProgressResetSnackbar}
              values={{
                name: _.get(course, 'name', ''),
              }}
            />
          }
          description={
            <div>
              <FormattedHTMLMessage
                {...messages.courseProgressResetDescription}
                values={{
                  teacher: formatMessage(
                    isProfessionalMainGroup(auth)
                      ? messages.teacherProfessional
                      : messages.teacher,
                  ),
                }}
              />
            </div>
          }
          deleteBtnLabel={
            <FormattedMessage {...messages.resetCourseProgress} />
          }
        />

        <Snackbar
          open={isOldBrowserWarning}
          onClose={this.handleCloseOldBrowserSnackbar}
          autoHideDuration={3000}
          message={formatMessage(messages.browserDoesNotSupportCaching)}
        />
      </>
    );
  }
}
